import { Component, EventListener, GondelBaseComponent } from '@gondel/core';

const selectors = {
	copyToClipboard: '.js-m-anchor-trigger__copy-to-clipboard',
};

@Component('AnchorTrigger')
export class AnchorTrigger extends GondelBaseComponent {
	@EventListener('click', selectors.copyToClipboard)
	public _onCopyToClipboardClick() {
		const reactsTo = this._ctx.id;

		const url = new URL(window.location.href);
		url.hash = reactsTo;

		navigator.clipboard.writeText(url.toString());
	}
}
